module.exports = __webpack_public_path__ + "img/sara-mamilonne.2c10b003.jpg";